import React from 'react'


function Footer() {
    return (
        <footer>
            <p> Ⓒ 2022 #VANLIFE</p>
        </footer>
    )
}

export default Footer